import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  checkoutData: null,
  couponCode: "",
  couponAmount: 0,
};

const checkoutPageSlice = createSlice({
  name: "checkoutData",
  initialState,
  reducers: {
    setCheckoutData: (state, action) => {
      state.checkoutData = action.payload;
    },
    setCouponCode: (state, action) => {
      state.couponCode = action.payload;
    },
    setCouponAmount: (state, action) => {
      state.couponAmount = action.payload;
    },
    resetCheckoutState: () => initialState,
  },
});

export const { setCheckoutData, setCouponCode, setCouponAmount } =
  checkoutPageSlice.actions;
export default checkoutPageSlice.reducer;
